import { MTypography } from '../MTypography/MTypography';

export const OtherFactorsDisclaimer = () => (
  <div>
    <MTypography variant='body1' weight='bold'>
      Other factors your investment might not get accepted:
    </MTypography>
    <ul>
      <li>
        <MTypography variant='body1'>
          Unless the offering statement or registration statement has been qualified or declared effective by the
          Securities and Exchange Commission, as applicable, no money or other consideration is being solicited, and if
          sent, will not be accepted.
        </MTypography>
      </li>
      <li>
        <MTypography variant='body1'>
          No sales will be made or commitments to purchase accepted until the offering statement or registration
          statement relating to this offering has been qualified or declared effective by the Securities and Exchange
          Commission.
        </MTypography>
      </li>
      <li>
        <MTypography variant='body1'>A prospective purchaser’s indication of interest is non-binding.</MTypography>
      </li>
    </ul>
  </div>
);
